module.exports = __webpack_public_path__ + "img/mg.92ba3863.svg";